import type { GroupChannel } from '@sendbird/chat/groupChannel';

export type ChannelMentionFlagMap = Record<string, boolean>;

const CHANNEL_URL_BATCH_SIZE = 20;

export function getChannelUnreadMentionCount(channel: GroupChannel | undefined): number {
  return (channel as GroupChannel & { unreadMentionCount?: number })?.unreadMentionCount ?? 0;
}

export function hasUnreadMentionOnChannel(
  channel: GroupChannel | undefined,
  selectedChannelUrl?: string,
): boolean {
  if (!channel?.url) return false;
  if (selectedChannelUrl && channel.url === selectedChannelUrl) return false;
  return getChannelUnreadMentionCount(channel) > 0;
}

export async function fetchChannelMentionFlags(
  sdk: {
    groupChannel: {
      createMyGroupChannelListQuery: (params: object) => {
        next: () => Promise<GroupChannel[]>;
      };
    };
  },
  channelUrls: string[],
  selectedChannelUrl?: string,
): Promise<ChannelMentionFlagMap> {
  const uniqueUrls = [...new Set(channelUrls.filter(Boolean))];
  const flags: ChannelMentionFlagMap = {};

  for (let index = 0; index < uniqueUrls.length; index += CHANNEL_URL_BATCH_SIZE) {
    const batch = uniqueUrls.slice(index, index + CHANNEL_URL_BATCH_SIZE);
    const query = sdk.groupChannel.createMyGroupChannelListQuery({
      channelUrlsFilter: batch,
      limit: batch.length,
      includeEmpty: true,
    });
    const channels = await query.next();
    for (const channel of channels) {
      flags[channel.url] = hasUnreadMentionOnChannel(channel, selectedChannelUrl);
    }
  }

  return flags;
}
